import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortByTenure'
})
export class SortByTenurePipe implements PipeTransform {

  transform(value: any[], sortBy: 'month' | 'bank'): any[] {
    if (!value || !sortBy) return value;
    return value.slice().sort((a, b) => {
      if (sortBy === 'month') {
        const tenureA = parseInt(a.tenureMonths, 10);
        const tenureB = parseInt(b.tenureMonths, 10);
        return tenureA - tenureB;
      } else if (sortBy === 'bank') {
        return a.gtwName.localeCompare(b.gtwName);
      }
      return 0;
    });
  }

}
